import './Layout.css';
import { ReactNode } from 'react';

type LayoutProps = {
	type: 'columns' | 'two-pane';
	children: ReactNode;
};

export const Layout = ({ type, children }: LayoutProps) => {
	return <div className={`layout ${type}`}>{children}</div>;
};
